import { Diffuseur } from "../../../../models/diffuseur";

export class PreferenceDiffuseurTableau {
  id: number;
  titre: string;
  compteur: number;
  diffuseurs: Diffuseur[];
  dateCreation: Date;
}
